export const dayNamesTranslation = {
  en: {
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
    7: 'Sun'
  },
  ru: {
    1: 'Пн',
    2: 'Вт',
    3: 'Ср',
    4: 'Чт',
    5: 'Пт',
    6: 'Сб',
    7: 'Вс'
  },
  uk: {
    1: 'Пн',
    2: 'Вт',
    3: 'Ср',
    4: 'Чт',
    5: 'Пт',
    6: 'Сб',
    7: 'Нд'
  },
  az: {
    1: 'B.e.',
    2: 'Ç.a.',
    3: 'Ç.',
    4: 'C.a.',
    5: 'C.',
    6: 'Ş.',
    7: 'B.'
  }
};
